import type {
  Theme,
  ThemeOptions,
  ComponentsOverrides,
  ComponentsVariants
} from '@mui/material/styles';

// https://mui.com/customization/theme-components/#default-props
export const defaultProps = {};

// https://mui.com/customization/theme-components/#global-style-overrides
export const styleOverrides: ComponentsOverrides<Theme>['JobSearchBox'] = {
  root: ({ theme, ownerState }) => ({
    ...theme.mixins.applyBackgroundColor({ ownerState, theme }),
    'containerType': 'inline-size',
    'position': 'relative',
    'width': '100%',
    'display': 'flex',
    'flexDirection': 'column',

    '[class*="Background-root"] + [class*=Section-contentWrap] & [class*=mainContentWrap]': {
      padding: 'var(--grid-gap)',
      paddingTop: 0
    }
  }),

  contentOuterGrid: {
    '> *': {
      gridColumnStart: 'auto'
    }
  },

  introText: { gridColumn: 'start / end' },

  // container: () => ({}),

  filtersContainer: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 20,
    width: '100%',

    [theme.breakpoints.up('sm')]: {
      gridColumn: 'two-start/seven-end'
    },

    [theme.breakpoints.up('md')]: {
      gridColumn: 'three-start/ten-end'
    },

    [theme.breakpoints.up('lg')]: {
      gridColumn: 'four-start/nine-end'
    }
  })
};

// https://mui.com/customization/theme-components/#adding-new-component-variants
const createVariants = (_theme: Theme): ComponentsVariants['JobSearchBox'] => [];

export default (theme: Theme): ThemeOptions => ({
  components: {
    JobSearchBox: {
      defaultProps,
      styleOverrides,
      variants: createVariants(theme)
    }
  }
});
